'use client'

import { ReactNode } from 'react'
import { Dialog as VintedModal, Divider } from '@vinted/web-ui'

import FilterSelectionButton from '../FilterSelectionButton'

type Props = {
  isOpen: boolean
  children?: ReactNode
  hideSubmitButton?: boolean
  testId?: string
  totalItemsCount?: number | null
  totalCountMax?: number | null
  isAsyncFacet?: boolean
  renderNavigation?: () => ReactNode
  onSubmit?: () => void
}

const FilterModal = ({
  isOpen,
  children,
  hideSubmitButton = false,
  testId,
  totalItemsCount,
  totalCountMax,
  isAsyncFacet,
  renderNavigation,
  onSubmit,
}: Props) => {
  return (
    <VintedModal
      show={isOpen}
      className="u-fill-width u-fill-height u-flexbox u-flex-direction-column"
      isModal={false}
      testId={testId}
    >
      {renderNavigation && (
        <div className="u-flex-shrink-none">
          {renderNavigation()}
          <Divider />
        </div>
      )}
      <div className="u-overflow-auto u-fill-height">{children}</div>
      {!hideSubmitButton && (
        <FilterSelectionButton
          onSubmit={onSubmit}
          totalItemsCount={totalItemsCount}
          maxItemsCount={totalCountMax}
          isAsync={isAsyncFacet}
        />
      )}
    </VintedModal>
  )
}

export default FilterModal
